export enum RouteName {
    // Generators
    GeneratorsReportsViewCondition = 'Generators_Reports_View_Condition',
    GeneratorsVisualInspectionImages = 'Generators_VisualInspection_Images',
}